import React, { useState } from "react";
import "./WhatsAppContact.css";

// Inline WhatsApp SVG icon — no extra npm package needed
function WhatsAppIcon({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

const PRODUCTS = [
  "Cumin Seeds",
  "Fennel Seeds",
  "Coriander Seeds",
  "Black Sesame Seeds",
  "White Sesame Seeds",
  "Red Chilly",
  "Other",
];

const INITIAL_FORM = {
  name: "",
  email: "",
  phone: "",
  product: "",
  quantity: "",
  message: "",
};

function WhatsAppContact() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setSubmitting(true);
    setError("");

    try {
      const res = await fetch("/api/whatsapp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && data.success) {
        setSuccess(true);
        setSubmitting(false);
        // Reset after 6 seconds
        setTimeout(() => {
          setSuccess(false);
          setForm(INITIAL_FORM);
        }, 6000);
      } else {
        setError(
          data.error ||
            "Could not send your inquiry. Please try again or email info@agronexustrading.in."
        );
        setSubmitting(false);
      }
    } catch (err) {
      console.error("[WhatsAppContact] fetch error:", err);
      setError(
        "Network error. Please check your connection and try again."
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="wac-wrap">
      <h2 className="wac-heading">
        <span className="wac-icon">
          <WhatsAppIcon size={28} />
        </span>
        Send us a WhatsApp Inquiry
      </h2>
      <p className="wac-lede">
        Fill in the form below. Your message lands directly in our{" "}
        <span className="wac-lede__accent">WhatsApp Business inbox</span> — we
        typically reply within a few hours.
      </p>

      {success ? (
        <div className="wac-success" role="status">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="28"
            height="28"
            aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <p>
            Your inquiry has been sent!{" "}
            <strong>We'll reply on WhatsApp shortly.</strong>
          </p>
        </div>
      ) : (
        <form className="wac-form" onSubmit={handleSubmit} noValidate>
          <div className="wac-row">
            <label className="wac-field">
              <span className="wac-label">
                Full Name <span className="wac-required">*</span>
              </span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your full name"
                required
                maxLength={200}
                autoComplete="name"
              />
            </label>
            <label className="wac-field">
              <span className="wac-label">Email</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                autoComplete="email"
              />
            </label>
          </div>

          <div className="wac-row">
            <label className="wac-field">
              <span className="wac-label">Phone / WhatsApp Number</span>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+91 98765 43210"
                autoComplete="tel"
              />
            </label>
            <label className="wac-field">
              <span className="wac-label">
                Product Interest <span className="wac-required">*</span>
              </span>
              <select
                name="product"
                value={form.product}
                onChange={handleChange}
                required
              >
                <option value="">Select a product…</option>
                {PRODUCTS.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="wac-row">
            <label className="wac-field">
              <span className="wac-label">Quantity (MT)</span>
              <input
                type="number"
                name="quantity"
                value={form.quantity}
                onChange={handleChange}
                placeholder="e.g. 5"
                min="0"
                step="0.1"
              />
            </label>
            <div className="wac-field wac-field--empty" aria-hidden="true" />
          </div>

          <label className="wac-field wac-field--full">
            <span className="wac-label">
              Message <span className="wac-required">*</span>
            </span>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Tell us your target market, purity grade, packaging preference, or any other requirements…"
              required
              rows={5}
              maxLength={5000}
            />
          </label>

          {error && (
            <p className="wac-error" role="alert">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="wac-btn"
            disabled={submitting}
            aria-busy={submitting}
          >
            {submitting ? (
              <>
                <span className="wac-spinner" aria-hidden="true" />
                Sending…
              </>
            ) : (
              <>
                <WhatsAppIcon size={18} />
                Send via WhatsApp
              </>
            )}
          </button>
        </form>
      )}
    </div>
  );
}

export default WhatsAppContact;
